"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicProductListsBySearchTerm = exports.getPublicProductList = exports.getProductListItem = exports.getCustomerProductLists = exports.getCustomerProductListItem = exports.getCustomerProductList = exports.getCustomerPaymentInstrument = exports.getCustomerOrders = exports.getCustomerBaskets = exports.getCustomerAddress = exports.getCustomer = exports.default = void 0;
/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const getCustomer = exports.getCustomer = ['organizationId', 'customerId', 'siteId'];
const getCustomerAddress = exports.getCustomerAddress = ['organizationId', 'customerId', 'addressName', 'siteId'];
const getCustomerBaskets = exports.getCustomerBaskets = ['organizationId', 'customerId', 'siteId'];
const getCustomerOrders = exports.getCustomerOrders = ['organizationId', 'customerId', 'crossSites', 'from', 'until', 'status', 'siteId', 'offset', 'limit'];
const getCustomerPaymentInstrument = exports.getCustomerPaymentInstrument = ['organizationId', 'customerId', 'paymentInstrumentId', 'siteId'];
const getCustomerProductLists = exports.getCustomerProductLists = ['organizationId', 'customerId', 'siteId'];
const getCustomerProductList = exports.getCustomerProductList = ['organizationId', 'customerId', 'listId', 'siteId'];
const getCustomerProductListItem = exports.getCustomerProductListItem = ['organizationId', 'customerId', 'listId', 'itemId', 'siteId'];
const getPublicProductListsBySearchTerm = exports.getPublicProductListsBySearchTerm = ['organizationId', 'email', 'firstName', 'lastName', 'siteId'];
const getPublicProductList = exports.getPublicProductList = ['organizationId', 'listId', 'siteId'];
const getProductListItem = exports.getProductListItem = ['organizationId', 'listId', 'itemId', 'siteId'];
// TODO: Re-implement (and update description from RAML spec) when the endpoint exits closed beta.
// export const getExternalProfile = [
//     'organizationId',
//     'externalId',
//     'authenticationProviderId',
//     'siteId'
// ] as const
var _default = exports.default = {
  getCustomer,
  getCustomerAddress,
  getCustomerBaskets,
  getCustomerOrders,
  getCustomerPaymentInstrument,
  getCustomerProductList,
  getCustomerProductLists,
  getCustomerProductListItem,
  getPublicProductListsBySearchTerm,
  getPublicProductList,
  getProductListItem
  // getExternalProfile
};